// tslint:disable: no-implicit-dependencies
import * as React from 'react';
import * as styles from './VisibleViolationsWarning.css';
import { IVisibleViolationsWarningProps } from './types';
import { Link } from '../common/Link';
const warningIcon = require('./images/warning.png');

export const VisibleViolationsWarning = (props: IVisibleViolationsWarningProps) => {
  const { handleForcePublishClick } = props;

  return (
    <div className={styles['wrapper']}>
      <img src={warningIcon} width={20} height={20} className={styles['icon']} />
      <div className={styles['message']}>
        В&nbsp;объявлении найдены нарушения.
        {' '}
        <Link onClick={handleForcePublishClick}>
          <span className={styles['link']}>Всё равно разместить</span>
        </Link>
      </div>
    </div>
  );
};
